import React from 'react';
import EmptyPage from '../EmptyPage';

const WorkFavoritesPage: React.FC = () => {
  return (
    <EmptyPage
      title="즐겨찾기"
      icon="Star"
      description="자주 사용하는 작업과 프로젝트를 즐겨찾기로 관리합니다."
    />
  );
};

export default WorkFavoritesPage;
